"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f257 = void 0;
exports.f257 = {
    "āng-kú": [
        3084
    ],
    "āwillisāpan nāwatl": [
        5556
    ],
    "āwillisāpan": [
        5556
    ]
};
